import React, { FunctionComponent } from "react";
import { Section } from "../../../core/layout/view/elements/section.elements";

const Left: FunctionComponent = () => {
  return <Section>Left Panel</Section>;
};

export default Left;
